import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.pick.pickMissingItemsDialog.title',
    defaultMessage: 'Missing products',
    description: 'Title of the pick missing items dialog',
  },
  properties: {
    picked: {
      id: 'properties.picked',
      defaultMessage: 'Picked',
      description: 'Label of the property picked',
    },
    quantity: {
      id: 'properties.quantity',
      defaultMessage: 'Quantity',
      description: 'Label of the property quantity',
    },
  },
  actions: {
    finish: {
      id: 'actions.finish',
      defaultMessage: 'Finish',
      description: 'Label of the finish action',
    },
  },
  itemQuantityDialog: {
    title: {
      id: 'pages.pick.itemQuantityDialog.title',
      defaultMessage: 'Pick',
      description: 'Title of the item quantity dialog',
    },
  },
  feedback: {
    missingItemsNotReported: {
      id: 'pages.pick.pickMissingItemsDialog.feedback.missingItemsNotReported',
      defaultMessage: 'Missing items could not be reported',
      description: 'Error message of the report missing items action',
    },
  },
};

export default defineMessages(translations);
